import { isMobile } from 'react-device-detect';
import { CountryUtils } from '../country';
import { MATRIX_PRODUCT_PATH, packageId } from '@shared/matrix/const';
import { LSK } from '../storage/config';

/**
 * 判断当前是否为pwa应用环境
 * @returns
 */
export const isInPWA = () => {
	return (
		window.matchMedia('(display-mode: standalone)').matches ||
		(window.navigator as any).standalone === true
	);
};

/**
 * 判断当前是否为 android twa app 环境
 * @returns
 */
export const isInAndroidApp = () => {
	return document.referrer.includes('android-app');
};

/**
 * 判断当前是否为 android webview app 环境
 * @returns
 */
export const isWebviewApp = window.navigator.userAgent.includes('a1.art.app');

/**
 * 判断当前是否为  app 环境
 * @returns
 */
export const isA1App = window.navigator.userAgent.endsWith('a1.art.app');
/**
 * 判断仅为web网页，不包括h5
 */
export const isOnlyWeb =
	window.navigator.userAgent.includes('Macintosh') ||
	window.navigator.userAgent.includes('Windows');

/**
 * 判断当前是否为 矩阵 app 环境
 * @returns
 */
export const isMatrixApp = isWebviewApp && !isA1App;

export const openChristmas = false;

export const isChristmas = isA1App && openChristmas;

export const isAnniversary = isA1App && true;

export const isFestiveAtmosphere = isAnniversary || CountryUtils.isLasserBairam;

export const isH5SharePage = !isA1App && window.location.href.includes('source=share');

export const getAppHomeToolBgColor = () => {
	if (CountryUtils.isLasserBairam) {
		return '#F3FEF8';
	}
	if (CountryUtils.isEaster) {
		return '#F6FFFB';
	}
	if (isAnniversary) {
		return '#FFF8F8';
	}
	return '#FBFAFB';
};

/**
 * 判断当前是哪个app 环境
 * @returns
 */
export const detectApp: () => 'a1App' | 'christmas' = () => {
	const userAgent = window.navigator.userAgent;
	if (userAgent.endsWith('a1.art.app')) return 'a1App';
	// else if (userAgent.includes('popdoll.app')) return 'popDoll';
	// else if (userAgent.includes('minimix.app')) return 'miniMix';
	// eslint-disable-next-line no-dupe-else-if
	else if (userAgent.endsWith('a1.art.app') && openChristmas) return 'christmas';
	else return 'a1App';
};

/**
 * 判断当前是否为chrome浏览器还是safari或者是其他
 * @returns
 */
export const detectBrowser: () => 'Chinese' | 'Chrome' | 'Safari' | 'Other' = () => {
	const userAgent = navigator.userAgent.toLowerCase();
	if (/huawei|xiaomi|miui|oppo|vivo|meizu/.test(userAgent)) {
		return 'Chinese'; // 国内安卓自带浏览器
	} else if (userAgent.includes('chrome') || userAgent.includes('crios')) {
		return 'Chrome';
	} else if (userAgent.includes('safari')) {
		return 'Safari';
	} else {
		return 'Other';
	}
};

/**
 * 判断当前是否可以使用google play支付
 */
export const isGooglePlayPaymentAvailable =
	window.AndroidInterface &&
	typeof window.AndroidInterface.launchGoogleBillingPurchase === 'function';

/**
 * 判断当前是否可以使用google play订阅升级
 */
export const isGooglePlaySubscriptionChangeAvailable =
	window.AndroidInterface &&
	typeof window.AndroidInterface.processSubscriptionChange === 'function';

export const isDownloadImageAvailable =
	window.AndroidInterface && typeof window.AndroidInterface?.downloadImage === 'function';

export const isTriggerShareAvailable =
	window.AndroidInterface && typeof window.AndroidInterface?.triggerShare === 'function';

/**
 * 判断当前是否可以使用facebook登录
 */
// export const isFacebookLoginAvailable =
// 	!isWebviewApp ||
// 	(window.AndroidInterface && typeof window.AndroidInterface.triggerFacebookSignIn === 'function');
export const isFacebookLoginAvailable = false;

/**
 * 判断当前是否为webview 全屏显示
 */
export const isWebviewFullscreen =
	window.AndroidInterface && typeof window.AndroidInterface.setStatusBarTextColor === 'function';

/**
 * 判断当前是否可以获取通知权限开启情况
 */
export const isGetNotificationsEnabledAvailable =
	window.AndroidInterface && typeof window.AndroidInterface.areNotificationsEnabled === 'function';

/**
 * 判断当前是否可以购买加量包
 */
export const isCreditPackAvailable =
	window.AndroidInterface &&
	typeof window.AndroidInterface.launchGoogleBillingOneTimePurchase === 'function';

// Android app 能力判断
export const AndroidAbilityCheck = {
	isGetNotificationsEnabledAvailable,
	isWebviewFullscreen,
	isTriggerShareAvailable,
	isDownloadImageAvailable,
	isGooglePlaySubscriptionChangeAvailable,
	isGooglePlayPaymentAvailable,
	get isCreditPackAvailable() {
		return isCreditPackAvailable || localStorage.getItem(LSK.DEBUG_CREDIT_PACK_AVAILABLE) === 'true';
	},
};

export enum ClientType {
	ANDROID = 'android',
	H5 = 'h5',
	PC = 'pc',
}

export const A1AppOrigin = '20001';

export const distinguishClientType = () => {
	if (isA1App) {
		return ClientType.ANDROID;
	}
	if (isMobile && !isA1App) {
		return ClientType.H5;
	}
	if (isOnlyWeb) {
		return ClientType.PC;
	}
};

/** !仅图片上传使用 */
export const detectEnvironmentType = () => {
	if (location.pathname.includes('faceswap')) return MATRIX_PRODUCT_PATH + '_faceswap';
	return MATRIX_PRODUCT_PATH;
};

export const { termsServiceUrl, privacyPolicyUrl } = {
	termsServiceUrl: 'https://a1.art/privacy-terms',
	privacyPolicyUrl: 'https://a1.art/privacy-policy',
};

/**
 * 判断当前webview app是否需要更新
 */
export const judgeAppUpdate = () => {
	return false;
};

export const judgeCanUseFreeTrial = () => {
	return true;
};

export const judgeVideoDownloadCallbackAvailable = () => {
	return true;
};

export const judgeCanUseSVip = () => {
	return true;
};

export const isGoogleBot = () => {
	const userAgent = navigator.userAgent.toLowerCase();
	return userAgent.includes('googlebot') || userAgent.includes('bingbot');
};

export const APPGooglePlayUrl = `https://play.google.com/store/apps/details?id=${packageId}`;

export const AppStoreUrl = `https://apps.apple.com/us/app/a1-art-fun-ai-photo-generator/id6748423076`;

/** --- 本来可以直接用上面的judgeCanUseSVip, 但感觉还是下面这新写的更好一点, 就新写了一个. 之后 parseVersion和 compareVersion别人也能用--- */
const parseVersion = (v: string): number[] => {
	return v
		.replace(/^v/i, '') // 去掉开头的 v 或 V
		.split('.')
		.map((i) => Number(i) || 0); // 转成数字，非数字默认 0
};

// 比较2版本的大小: 是否 v1 < v2
export const compareVersion = (v1: string, v2: string) => {
	const ver1 = parseVersion(v1);
	const ver2 = parseVersion(v2);
	const len = Math.max(ver1.length, ver2.length);
	for (let i = 0; i < len; i++) {
		const a = ver1[i] ?? 0;
		const b = ver2[i] ?? 0;
		if (a < b) return true;
		if (a > b) return false;
	}
	return false; // 完全相等
};
